import CommonFun from '../commontools/CommonFun.js'
import apiReq from '../commontools/api.js'
export function GetAllRole(){
	var url='/Role/GetAllRole';
	return apiReq.get(url);
}
export function GetRoleByUserID(userid){
	var url='/Role/GetRoleByUserID/'+userid;
	return apiReq.get(url);
}
export function AddRole(info){
	var url='/Role/AddRole'
	var p={
		'data':info
	}
	return apiReq.post(url,p);
}
export function EditRole(info){
	var url='/Role/EditRole';
	var p={
		'data':info
	}
	return apiReq.post(url,p);
}
export function GetRolePermissionByRoleID(roleid){
	var url='/Role/GetRolePermissionByRoleID/'+roleid;
	return apiReq.get(url);
}
export function SavePermission(roleid,permissionlist)
{
	var url='/Role/SavePermission';
	var p={
		'data':{
			'roleid':roleid,
			'permissionlist':permissionlist
		}
		
	}
	return apiReq.post(url,p);
}
export default {
	GetAllRole,
	GetRoleByUserID,
	AddRole,
	EditRole,
	SavePermission,
	GetRolePermissionByRoleID
}